import { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import moment from "moment";
import Select from "react-select";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";

import Loader from "../reusables/Loader";
import Swal from "sweetalert2";
import * as api from "../../api";
import {
  bookingServiceOptions,
  regionOptions,
  idTypeOptions,
} from "../../utils/signupPartnerOptions";

const SignupPartner = () => {
  const [loading, setLoading] = useState(false);
  const [errorIndicator, setErrorIndicator] = useState();
  const [signupError, setsignupError] = useState(null);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [practiceOptions, setPracticeOptions] = useState([]);
  const [signupForm, setSignupForm] = useState({
    email: "",
    password: "",
    firstName: "",
    lastName: "",
    dateOfBirth: "",
    homeAddress: "",
    facilityIds: [],
    practices: [],
    contactNumber: "",
    residentialStatus: "",
    bookingService: "",
    region: "",
    workDayAvailability: {
      Monday: "08:00 AM - 05:00 PM",
      Tuesday: "08:00 AM - 05:00 PM",
      Wednesday: "08:00 AM - 05:00 PM",
      Thursday: "08:00 AM - 05:00 PM",
      Friday: "08:00 AM - 05:00 PM",
    },
    idType: "",
    identification: [],
    certificate: [],
    clientApp: ["HAPIPARTNERS"],
  });

  const [selectedDiscipline, setSelectedDiscipline] = useState([]);
  const [selectedBookingService, setSelectedBookingService] = useState([]);
  const [selectedRegion, setSelectedRegion] = useState([]);
  const [selectedIdType, setSelectedIdType] = useState([]);

  useEffect(() => {
    const getPractice = async () => {
      setLoading(true);
      try {
        let practicesArray = [];
        const data = await api.getPractices();
        const practice = data.data.data;
        practice.forEach((item) => {
          practicesArray.push({
            value: item.name,
            label: item.label,
          });
        });
        setPracticeOptions(practicesArray);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    };

    getPractice();
  }, []);

  const [mobileNumber, setMobileNumber] = useState("");
  const [birthday, setBirthday] = useState({
    day: moment().date().toString(),
    month: moment().format("MM"),
    year: moment().year().toString(),
  });

  const [availability, setAvailability] = useState({
    monday: { start: "08:00", end: "17:00" },
    tuesday: { start: "08:00", end: "17:00" },
    wednesday: { start: "08:00", end: "17:00" },
    thursday: { start: "08:00", end: "17:00" },
    friday: { start: "08:00", end: "17:00" },
  });

  const handleAvailabilityChange = (day, field, value) => {
    setAvailability((prev) => ({
      ...prev,
      [day]: {
        ...prev[day],
        [field]: value,
      },
    }));
  };

  const formatTime = (time) => {
    if (!time) return "";
    return moment(time, "HH:mm").format("hh:mm A");
  };

  useEffect(() => {
    const formatted = {};
    Object.entries(availability).forEach(([day, { start, end }]) => {
      const Day = day.charAt(0).toUpperCase() + day.slice(1);
      if (start && end) {
        formatted[Day] = `${formatTime(start)} - ${formatTime(end)}`;
      } else {
        formatted[Day] = "";
      }
    });
    setSignupForm((prev) => ({
      ...prev,
      workDayAvailability: formatted,
    }));
  }, [availability]);

  useEffect(() => {
    setSignupForm((prev) => ({
      ...prev,
      contactNumber: mobileNumber,
    }));
  }, [mobileNumber]);

  useEffect(() => {
    setSignupForm((prev) => ({
      ...prev,
      practices: selectedDiscipline.map((item) => item.value),
    }));
  }, [selectedDiscipline]);

  useEffect(() => {
    setSignupForm((prev) => ({
      ...prev,
      bookingService: selectedBookingService?.value || "",
    }));
  }, [selectedBookingService]);

  useEffect(() => {
    setSignupForm((prev) => ({
      ...prev,
      region: selectedRegion?.value || "",
    }));
  }, [selectedRegion]);

  useEffect(() => {
    setSignupForm((prev) => ({
      ...prev,
      idType: selectedIdType?.value || "",
    }));
  }, [selectedIdType]);

  useEffect(() => {
    if (birthday.day && birthday.month && birthday.year) {
      const combinedDate = moment(
        `${birthday.year}-${birthday.month}-${birthday.day}`,
        "YYYY-MM-DD"
      ).format("YYYY-MM-DD");
      setSignupForm({
        ...signupForm,
        dateOfBirth: combinedDate,
      });
    }
  }, [birthday.day, birthday.month, birthday.year]);

  useEffect(() => {
    if (
      (confirmPassword && signupForm.password !== confirmPassword) ||
      (signupForm.password && signupForm.password.length < 8)
    ) {
      setErrorIndicator("password");
    } else if (errorIndicator === "password") {
      setErrorIndicator(undefined);
    }
  }, [signupForm.password, confirmPassword]);

  useEffect(() => {
    if (signupError) {
      const errors = signupError.map((err) => err.message).join("<br>");
      Swal.fire({
        title: "Error!",
        html: errors,
        icon: "error",
        confirmButtonColor: "#325ba6",
      });
    }
  }, [signupError]);

  const handleChange = (event) => {
    const { value, name } = event.target;
    setSignupForm({ ...signupForm, [name]: value });
  };

  const handleSelectOption = (selected, name) => {
    if (name === "discipline") {
      setSelectedDiscipline(selected);
    } else if (name === "bookingService") {
      setSelectedBookingService(selected);
    } else if (name === "region") {
      setSelectedRegion(selected);
    } else {
      setSelectedIdType(selected);
    }
  };

  const imageHandleChange = (e, name) => {
    const tempFiles = Array.from(e.target.files).map((file) => file);
    if (tempFiles.filter((file) => file.size > 1000000).length > 0) {
      Swal.fire({
        html: "Can only upload files less than 1MB",
        icon: "error",
        title: "Error",
        confirmButtonColor: "#325ba6",
      });
      return;
    }
    setSignupForm({
      ...signupForm,
      [name]: tempFiles.filter((file) => file.size < 1000000),
    });
  };

  const handleChangeBirthday = (e) => {
    setBirthday({ ...birthday, [e.target.name]: e.target.value });
  };

  const renderDays = () => {
    const { month, year } = birthday;
    const numDays = moment(`${year}-${month}`, "YYYY-MM").daysInMonth();
    const days = [];

    for (let i = 1; i <= numDays; i++) {
      const dayValue = i < 10 ? `0${i}` : i;
      days.push(
        <option key={i} value={dayValue}>
          {dayValue}
        </option>
      );
    }
    return days;
  };

  const renderMonths = () => {
    const months = [];
    for (let i = 1; i <= 12; i++) {
      const monthValue = i < 10 ? `0${i}` : i;
      months.push(
        <option key={i} value={monthValue} className="text-center">
          {monthValue}
        </option>
      );
    }
    return months;
  };

  const renderYears = () => {
    const years = [];
    const currentYear = new Date().getFullYear();
    for (let i = currentYear; i >= 1900; i--) {
      years.push(
        <option key={i} value={i}>
          {i}
        </option>
      );
    }
    return years;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const formData = new FormData();

      // Append all fields except files
      Object.entries(signupForm).forEach(([key, value]) => {
        if (
          key === "certificate" ||
          key === "identification" ||
          key === "clientApp"
        )
          return;

        if (Array.isArray(value) || typeof value === "object") {
          formData.append(key, JSON.stringify(value));
        } else {
          formData.append(key, value);
        }
      });

      formData.append("clientApp[]", "HAPIPARTNERS");

      // Append certificate file(s)
      if (signupForm.certificate && signupForm.certificate.length) {
        signupForm.certificate.forEach((file) => {
          formData.append("certificate", file);
        });
      }

      // Append identification file(s)
      if (signupForm.identification && signupForm.identification.length) {
        signupForm.identification.forEach((file) => {
          formData.append("identification", file);
        });
      }

      const data = await api.signUpPractitioner(formData);
      console.log("data", data);
      Swal.fire({
        html: "Successfully signed up! An email will be sent once the admin approved your request!",
        icon: "success",
        title: "Success",
        confirmButtonColor: "#325ba6",
      });
      setSignupForm({
        email: "",
        password: "",
        firstName: "",
        lastName: "",
        dateOfBirth: "",
        homeAddress: "",
        facilityIds: [],
        practices: [],
        contactNumber: "",
        residentialStatus: "",
        bookingService: "",
        region: "",
        workDayAvailability: {
          Monday: "08:00 AM - 05:00 PM",
          Tuesday: "08:00 AM - 05:00 PM",
          Wednesday: "08:00 AM - 05:00 PM",
          Thursday: "08:00 AM - 05:00 PM",
          Friday: "08:00 AM - 05:00 PM",
        },
        idType: "",
        identification: [],
        certificate: [],
        clientApp: ["HAPIPARTNERS"],
      });
      setMobileNumber("");
      setConfirmPassword("");
      setBirthday({
        day: moment().date().toString(),
        month: moment().format("MM"),
        year: moment().year().toString(),
      });
      setSelectedDiscipline([]);
      setSelectedBookingService([]);
      setSelectedRegion([]);
      setSelectedIdType([]);
    } catch (error) {
      setsignupError(error.response.data.errors);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading ? (
        <div className="h-100 d-flex">
          <Loader />
        </div>
      ) : (
        <div className="container mt-3" style={{ margin: "150px auto" }}>
          <div className="container p-3 mt-2 bg-light border shadow-sm">
            <form>
              <div className="form-group">
                <p
                  className="text-center lead mb-4"
                  style={{ fontSize: "25px" }}
                >
                  Sign Up Partner
                </p>
                <div className="row">
                  <div className="col-sm-12 col-md-6">
                    <label htmlFor="firstName">First Name</label>
                    <input
                      onChange={handleChange}
                      className={`form-control ${
                        errorIndicator === "firstName"
                          ? "border border-danger"
                          : ""
                      }`}
                      type="text"
                      name="firstName"
                      value={signupForm.firstName.toLowerCase() ?? ""}
                      autoComplete="off"
                    />
                  </div>
                  <div className="col-sm-12 col-md-6">
                    <label htmlFor="lastName">Last Name</label>
                    <input
                      onChange={handleChange}
                      className={`form-control ${
                        errorIndicator === "lastName"
                          ? "border border-danger"
                          : ""
                      }`}
                      type="text"
                      name="lastName"
                      value={signupForm.lastName.toLowerCase() ?? ""}
                      autoComplete="off"
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-12 col-md-4">
                    <label htmlFor="email">Email</label>
                    <input
                      onChange={handleChange}
                      className={`form-control ${
                        errorIndicator === "email" ? "border border-danger" : ""
                      }`}
                      type="email"
                      name="email"
                      value={signupForm.email.toLowerCase() ?? ""}
                      autoComplete="off"
                    />
                  </div>
                  <div className="col-sm-12 col-md-4">
                    <label htmlFor="password">Password</label>
                    <input
                      onChange={handleChange}
                      className={`form-control ${
                        errorIndicator === "password"
                          ? "border border-danger"
                          : ""
                      }`}
                      type="password"
                      name="password"
                      value={signupForm.password ?? ""}
                      autoComplete="off"
                    />
                    {errorIndicator === "password" && (
                      <span
                        className="text-danger"
                        style={{ fontSize: "0.9em" }}
                      >
                        {signupForm.password.length < 8
                          ? "Password must be at least 8 characters."
                          : signupForm.password !== confirmPassword
                          ? "Passwords do not match."
                          : ""}
                      </span>
                    )}
                  </div>
                  <div className="col-sm-12 col-md-4">
                    <label htmlFor="confirmPassword">Confirm Password</label>
                    <input
                      className={`form-control ${
                        errorIndicator === "password"
                          ? "border border-danger"
                          : ""
                      }`}
                      type="password"
                      name="confirmPassword"
                      value={confirmPassword ?? ""}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                      autoComplete="off"
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-12 col-md-6">
                    <label htmlFor="contactNumber">Contact Number</label>
                    <PhoneInput
                      className={`form-control phone-input ${
                        errorIndicator === "contactNumber"
                          ? "border border-danger"
                          : ""
                      }`}
                      international
                      countryCallingCodeEditable={false}
                      defaultCountry="GB"
                      value={mobileNumber}
                      onChange={setMobileNumber}
                    />
                  </div>
                  <div className="col-sm-12 col-md-6" style={{ zIndex: 1 }}>
                    <label htmlFor="dateOfBirth">Date Of Birth</label>
                    <div>
                      <label>
                        <select
                          className={`form-control ${
                            errorIndicator === "dateOfBirth"
                              ? "border border-danger"
                              : ""
                          }`}
                          name="day"
                          value={birthday.day ?? ""}
                          onChange={handleChangeBirthday}
                          required
                          style={{
                            border: "1px solid #ced4da",
                          }}
                        >
                          <option value="" disabled>
                            Day
                          </option>
                          {renderDays()}
                        </select>
                      </label>

                      <span className="mx-1">/</span>

                      <label>
                        <select
                          className={`form-control ${
                            errorIndicator === "dateOfBirth"
                              ? "border border-danger"
                              : ""
                          }`}
                          name="month"
                          value={birthday.month ?? ""}
                          onChange={handleChangeBirthday}
                          required
                          style={{
                            border: "1px solid #ced4da",
                          }}
                        >
                          <option value="" disabled>
                            Month
                          </option>
                          {renderMonths()}
                        </select>
                      </label>

                      <span className="mx-1">/</span>

                      <label>
                        <select
                          className={`form-control ${
                            errorIndicator === "dateOfBirth"
                              ? "border border-danger"
                              : ""
                          }`}
                          name="year"
                          value={birthday.year ?? ""}
                          onChange={handleChangeBirthday}
                          required
                          style={{
                            border: "1px solid #ced4da",
                          }}
                        >
                          <option value="" disabled>
                            Year
                          </option>
                          {renderYears()}
                        </select>
                      </label>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-12 col-md-6">
                    <label htmlFor="homeAddress">Address</label>
                    <input
                      onChange={handleChange}
                      className={`form-control ${
                        errorIndicator === "homeAddress"
                          ? "border border-danger"
                          : ""
                      }`}
                      type="text"
                      name="homeAddress"
                      value={signupForm.homeAddress ?? ""}
                      autoComplete="off"
                    />
                  </div>
                  <div className="col-sm-12 col-md-6">
                    <label htmlFor="residentialStatus">
                      Residential Status
                    </label>
                    <input
                      onChange={handleChange}
                      className={`form-control ${
                        errorIndicator === "residentialStatus"
                          ? "border border-danger"
                          : ""
                      }`}
                      type="text"
                      name="residentialStatus"
                      value={signupForm.residentialStatus ?? ""}
                      autoComplete="off"
                    />
                  </div>
                </div>

                <div className="row">
                  <div className="col-sm-12 col-md-4">
                    <label htmlFor="discipline">Discipline</label>
                    <Select
                      className={
                        errorIndicator === "discipline"
                          ? "border border-danger"
                          : ""
                      }
                      placeholder="Select Discipline"
                      isClearable
                      isMulti
                      options={practiceOptions}
                      value={selectedDiscipline}
                      onChange={(e) => handleSelectOption(e, "discipline")}
                      inputProps={{ autoComplete: "off" }}
                    />
                  </div>
                  <div className="col-sm-12 col-md-4">
                    <label htmlFor="bookingService">Booking Service</label>
                    <Select
                      className={
                        errorIndicator === "bookingService"
                          ? "border border-danger"
                          : ""
                      }
                      placeholder="Select Booking Service"
                      isClearable
                      options={bookingServiceOptions.map((item) => ({
                        value: item,
                        label: item,
                      }))}
                      value={selectedBookingService}
                      onChange={(e) => handleSelectOption(e, "bookingService")}
                      inputProps={{ autoComplete: "off" }}
                    />
                  </div>
                  <div className="col-sm-12 col-md-4">
                    <label htmlFor="region">Region</label>
                    <Select
                      className={
                        errorIndicator === "region"
                          ? "border border-danger"
                          : ""
                      }
                      placeholder="Select Region"
                      isClearable
                      options={regionOptions.map((item) => ({
                        value: item.split("(")[0].trim(),
                        label: item,
                      }))}
                      value={selectedRegion}
                      onChange={(e) => handleSelectOption(e, "region")}
                      inputProps={{ autoComplete: "off" }}
                    />
                  </div>
                </div>

                <div className="mt-1">
                  <label>Certificate and Identification</label>
                </div>

                <div className="row">
                  <div className="col-sm-12 col-md-6">
                    <label htmlFor="idType">ID Type</label>
                    <Select
                      className={
                        errorIndicator === "idType"
                          ? "border border-danger"
                          : ""
                      }
                      placeholder="Select ID Type"
                      isClearable
                      options={idTypeOptions.map((item) => ({
                        value: item,
                        label: item,
                      }))}
                      value={selectedIdType}
                      onChange={(e) => handleSelectOption(e, "idType")}
                      inputProps={{ autoComplete: "off" }}
                    />
                  </div>
                </div>

                <div className="d-md-flex mt-md-2">
                  <div className="col-sm-12 col-md-6">
                    <label>Certificate</label>
                    <div className="row">
                      <div className="col-12">
                        <input
                          type="file"
                          name="certificate"
                          onChange={(e) => imageHandleChange(e, "certificate")}
                          style={{ cursor: "pointer" }}
                          // multiple
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-12 col-md-6">
                    <label>ID</label>
                    <div className="row">
                      <div className="col-12">
                        <input
                          type="file"
                          name="identification"
                          onChange={(e) =>
                            imageHandleChange(e, "identification")
                          }
                          style={{ cursor: "pointer" }}
                          // multiple
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mt-2">
                  <label>Work Day and Time Availability</label>
                </div>

                <div className="row">
                  {["monday", "tuesday", "wednesday", "thursday", "friday"].map(
                    (day) => (
                      <div className="col-12 mb-2" key={day}>
                        <div className="d-flex align-items-center">
                          <label
                            className="me-2 text-capitalize mr-5"
                            style={{ width: 80 }}
                          >
                            {day.charAt(0).toUpperCase() + day.slice(1)}
                          </label>
                          <input
                            type="time"
                            className="form-control me-2"
                            value={availability[day].start}
                            onChange={(e) =>
                              handleAvailabilityChange(
                                day,
                                "start",
                                e.target.value
                              )
                            }
                            style={{ maxWidth: 130 }}
                          />
                          <span className="mx-1"> - </span>
                          <input
                            type="time"
                            className="form-control"
                            value={availability[day].end}
                            onChange={(e) =>
                              handleAvailabilityChange(
                                day,
                                "end",
                                e.target.value
                              )
                            }
                            style={{ maxWidth: 130 }}
                          />
                        </div>
                      </div>
                    )
                  )}
                </div>

                <button
                  className="btn btn-primary mt-3 w-100 py-3"
                  onClick={handleSubmit}
                  disabled={
                    errorIndicator === "password" ||
                    signupForm.password.length < 8 ||
                    signupForm.password !== confirmPassword
                  }
                >
                  Sign Up
                </button>
                <NavLink
                  className="text-center d-block mt-2"
                  to="/login"
                  // onClick={() => {
                  //   setErrorMessage("");
                  //   setErrorIndicator("");
                  //   setSuccessMessage("");
                  // }}
                >
                  Go back to login
                </NavLink>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default SignupPartner;
